var map = {
	"./events_conflict_blue.svg": "b274",
	"./events_crime_blue.svg": "ee4a",
	"./events_disasters_blue.svg": "68dc",
	"./events_elections_blue.svg": "7ae1",
	"./events_health_blue.svg": "06f3",
	"./events_political_terrorism_blue.svg": "3b6c",
	"./events_terrorism_blue.svg": "98a7",
	"./events_transportation_blue.svg": "d794",
	"./events_travel_blue.svg": "9542",
	"./events_unrest_blue.svg": "772d",
	"./events_war_blue.svg": "888c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8a6";